module.exports = __webpack_public_path__ + "img/arnevet_yes.01537061.png";